import { render } from "./draftReorderDialog.vue?vue&type=template&id=416e5a14"
import script from "./draftReorderDialog.vue?vue&type=script&lang=js"
export * from "./draftReorderDialog.vue?vue&type=script&lang=js"

import "./draftReorderDialog.vue?vue&type=style&index=0&id=416e5a14&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__